/**
 * change forgot password into create password
 */
(() => {
  // Create a URLSearchParams object from the current URL's query string
  const params = new URLSearchParams(window.location.search);
  if (params.get('type') === 'create-password') {
    const passwordData = window.createNewPassword;
    console.log(passwordData);

    const passwordReset = document.querySelector('.password-reset-form');
    passwordReset.querySelector('h2').innerHTML = passwordData.title;
    passwordReset.querySelector('p').innerHTML = passwordData.details;
    passwordReset.querySelector('button.btn-primary').innerHTML = passwordData.button;
    passwordReset.querySelector('.toggle-next').style.display = 'none';
  }
})();
